import { render, staticRenderFns } from "./x-money-input.vue?vue&type=template&id=0b3f466c&"
import script from "./x-money-input.vue?vue&type=script&lang=ts&"
export * from "./x-money-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b3f466c')) {
      api.createRecord('0b3f466c', component.options)
    } else {
      api.reload('0b3f466c', component.options)
    }
    module.hot.accept("./x-money-input.vue?vue&type=template&id=0b3f466c&", function () {
      api.rerender('0b3f466c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/x-money-input.vue"
export default component.exports